import { FC } from 'react';
import { Box, SxProps, Theme, useMediaQuery } from '@mui/material';
import { hostBackgroundStyles } from './host-background.styles';
import Showable from '../utils/showable';
import { clsx } from '../../utils/clsx';

export interface HostBackgroundProps {
	sx?: SxProps<Theme>;
	background?: string;
	primaryColor?: string | null;
	options?: {
		distance: number;
		time: number;
	};
}

export const HostBackground: FC<HostBackgroundProps> = (props) => {
	const { background, primaryColor, sx } = props;

	const isLessThanMd = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

	const styles = hostBackgroundStyles(background, primaryColor);

	return (
		<Box sx={clsx(styles.root, sx)}>
			<Showable hide={isLessThanMd}>
				<Box sx={styles.backgroundImage} />
			</Showable>
			<Box sx={styles.backgroundColor} />
		</Box>
	);
};
